<template>
  <div class="page">
    <div class="container pageCont">
      <div class="row">
        <div class="col-lg-3 leftMenu text-center">
          <div class="leftMenu-title flex">
            <img
              src="@/assets/workingicon.png"
              alt=""
              style="width: 30px; height: 30px; margin-right: 5px"
            />
            <div class="flex-column text-left">
              <h3 style="font-size: 25px; color: #333333; margin-bottom: 0 !important">
                个人中心
              </h3>
              <p style="font-size: 14px; color: #dbdbdb">PERSONAI CENTER</p>
            </div>
          </div>
          <div
            class="apiLeftMenu text-center"
            style="padding-top: 25px; padding-bottom: 25px; background: #f6f6f6"
          >
            <div
              class="apiLeftMenu-ever flex justify-content-space-around align-items"
              @click="menuChange(item)"
              v-for="(item, i) in menulist"
              :key="i"
              :style="changeStatus == item.id ? 'background:#FFFFFF;color:#0090FF;' : ''"
            >
              <span>{{ item.name }}</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
        <div class="col-lg-9 col-md-12 col-sm-12 col-12 rightCont">
          <!--头部-->
          <div class="rightCont-title user-none">
            <span>当前位置：</span>
            <span class="page-click" @click="tohome">首页</span>
            <i class="el-icon-arrow-right"></i>
            <span class="page-click">个人中心</span>
          </div>
          <!-- <div class="rightCont-menu-box">
						<div class="rightCont-menu flex align-items justify-content-space-between">
							<div class="flex align-items">
								<img src="@/assets/workingicon.png" alt="" style="width:20px;height:20px;margin-left:15px;">
								<div style="font-size:18px;color:#333333;margin-left:5px;">个人中心</div>
							</div>
							<van-icon name="plus" color="#666666" style="margin-right:15px;" />
						</div>
					</div> -->
          <!-- pc列表 -->
          <div class="rightCont-order user-none" v-if="list.length != 0">
            <div
              class="order-ever"
              style="margin-top: 10px"
              v-for="(item, i) in list"
              :key="i"
            >
              <div class="order-ever-title">
                <div
                  style="height: 100%"
                  class="order-box flex justify-content-space-between align-items"
                >
                  <div>
                    <span class="size-14 color-333">{{
                      item.orderTime.substring(0, 10)
                    }}</span>
                    <span class="size-14 color-333" style="margin-left: 10px"
                      >订单号：{{ item.orderNo }}</span
                    >
                  </div>
                  <div class="color-status">
                    {{
                      item.state == "1"
                        ? "待发货"
                        : item.state == "2"
                        ? "待收货"
                        : item.state == "3"
                        ? "已完成"
                        : ""
                    }}
                  </div>
                </div>
              </div>
              <div class="order-ever-info">
                <div class="order-box">
                  <div class="order-goods flex justify-content-space-between align-items">
                    <div
                      class="order-goods-ever flex align-items"
                      v-for="(a, e) in item.detailDtoList"
                      :key="e"
                    >
                      <img
                        :src="$path + a.image"
                        alt=""
                        style="width: 90px; height: 68px"
                      />
                      <div class="flex-column" style="margin-left: 5px">
                        <div class="color-333">{{ a.productName }} ￥{{ a.price }}</div>
                        <span>X {{ a.num }}</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="order-cont flex justify-content-space-between align-items"
                    style="margin-top: 10px"
                  >
                    <div class="size-14 color-666 flex">
                      <div style="width:60px;">收货人：</div>
                      <div>{{ item.name }} {{ item.phone }}</div>
                    </div>
                    <div class="size-14 color-money">总价：￥{{ item.totalMoney }}</div>
                  </div>
                  <div class="order-remark size-14 color-666 flex">
                    <div class="flex" style="width:60px;">地<p style="text-indent:1em;">址：</p></div>
                    <div>{{ item.address }}</div>
                  </div>
                  <div class="order-remark size-14 color-666 flex">
                    <div class="flex" style="width:60px;">备<p style="text-indent:1em;">注：</p></div>
                    <div>{{ item.remark }}</div>
                  </div>
                </div>
              </div>
              <div
                class="order-receiving flex-column align-items-end"
                v-if="item.state == '2'"
                style="margin-top: 10px"
              >
                <div
                  @click="toconfirmReceipt(item)"
                  class="order-btn flex justify-content-space-around align-items page-click"
                >
                  确认收货
                </div>
              </div>
            </div>
          </div>
          <!--分页-->
          <div
            class="text-center user-none"
            v-if="list.length != 0"
            style="margin-top: 20px"
          >
            <el-pagination
              layout="prev, pager, next"
              :page-size="rows"
              :total="total"
              @current-change="currentChange"
            ></el-pagination>
          </div>
          <div class="user-block">
            <van-tabs
              v-model="changeStatus"
              @change="tabChange"
              title-active-color="#333333"
              title-inactive-color="#999999"
            >
              <van-tab title="待发货" name="1">
                <div
                  class="monOrder-ever"
                  style="margin-top: 2vh"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <div class="monOrder-ever-title-box">
                    <div
                      class="mobOrder-ever-title flex justify-content-space-between align-items"
                    >
                      <div class="color-333" style="font-size: 12px">
                        <span>{{ item.orderTime.substring(0, 10) }}</span>
                        <span style="margin-left: 5px">订单号：{{ item.orderNo }}</span>
                      </div>
                      <div class="size-14" style="color: #ff6700">待发货</div>
                    </div>
                  </div>
                  <div class="monOrder-ever-info-box">
                    <div class="mobOrder-ever-info">
                      <div
                        class="mob-goods flex align-items justify-content-space-around"
                        v-for="(it, i) in item.detailDtoList"
                        :key="i"
                        style="margin-bottom: 10px"
                      >
                        <img
                          :src="$path + it.image"
                          alt=""
                          style="width: 90px; height: 68px"
                        />
                        <div
                          class="flex-column justify-content-space-between"
                          style="width: 200px"
                        >
                          <div
                            class="mob-goods-title flex justify-content-space-between align-items"
                          >
                            <span>{{ it.productName }}</span>
                            <span>￥{{ it.price }}</span>
                          </div>
                          <div class="mob-goods-num">X {{ it.num }}</div>
                        </div>
                      </div>
                      <div class="color-333 size-14 text-right">
                        总价：￥{{ item.totalMoney }}
                      </div>
                      <div class="size-14 color-666 text-right">
                        收货人：{{ item.name }} {{ item.phone }}
                      </div>
                      <div class="size-14 color-666 text-right">
                        地址：{{ item.address }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center" v-if="list.length != 0" style="margin-top: 20px">
                  <el-pagination
                    layout="prev, pager, next"
                    :page-size="rows"
                    :total="total"
                    @current-change="currentChange"
                  ></el-pagination>
                </div>
              </van-tab>
              <van-tab title="待收货" name="2">
                <div
                  class="monOrder-ever"
                  style="margin-top: 2vh"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <div class="monOrder-ever-title-box">
                    <div
                      class="mobOrder-ever-title flex justify-content-space-between align-items"
                    >
                      <div class="color-333" style="font-size: 12px">
                        <span>{{ item.orderTime.substring(0, 10) }}</span>
                        <span style="margin-left: 5px">订单号：{{ item.orderNo }}</span>
                      </div>
                      <div class="size-14" style="color: #ff6700">待收货</div>
                    </div>
                  </div>
                  <div class="monOrder-ever-info-box">
                    <div class="mobOrder-ever-info">
                      <div
                        class="mob-goods flex align-items justify-content-space-around"
                        v-for="(it, i) in item.detailDtoList"
                        :key="i"
                        style="margin-bottom: 10px"
                      >
                        <img
                          :src="$path + it.image"
                          alt=""
                          style="width: 90px; height: 68px"
                        />
                        <div
                          class="flex-column justify-content-space-between"
                          style="width: 200px"
                        >
                          <div
                            class="mob-goods-title flex justify-content-space-between align-items"
                          >
                            <span>{{ it.productName }}</span>
                            <span>￥{{ it.price }}</span>
                          </div>
                          <div class="mob-goods-num">X {{ it.num }}</div>
                        </div>
                      </div>
                      <div class="color-333 size-14 text-right">
                        总价：￥{{ item.totalMoney }}
                      </div>
                      <div class="size-14 color-666 text-right">
                        收货人：{{ item.name }} {{ item.phone }}
                      </div>
                      <div class="size-14 color-666 text-right">
                        地址：{{ item.address }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="mob-goods-btn-box flex justify-content-end"
                    style="margin-top: 5px"
                  >
                    <div
                      class="mob-goods-btn flex justify-content-space-around align-items"
                      @click="toconfirmReceipt2(item)"
                    >
                      确认收货
                    </div>
                  </div>
                </div>
                <div class="text-center" v-if="list.length != 0" style="margin-top: 20px">
                  <el-pagination
                    layout="prev, pager, next"
                    :page-size="rows"
                    :total="total"
                    @current-change="currentChange"
                  ></el-pagination>
                </div>
              </van-tab>
              <van-tab title="已完成" name="3">
                <div
                  class="monOrder-ever"
                  style="margin-top: 2vh"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <div class="monOrder-ever-title-box">
                    <div
                      class="mobOrder-ever-title flex justify-content-space-between align-items"
                    >
                      <div class="color-333" style="font-size: 12px">
                        <span>{{ item.orderTime.substring(0, 10) }}</span>
                        <span style="margin-left: 5px">订单号：{{ item.orderNo }}</span>
                      </div>
                      <div class="size-14" style="color: #ff6700">已完成</div>
                    </div>
                  </div>
                  <div class="monOrder-ever-info-box">
                    <div class="mobOrder-ever-info">
                      <div
                        class="mob-goods flex align-items justify-content-space-around"
                        v-for="(it, i) in item.detailDtoList"
                        :key="i"
                        style="margin-bottom: 10px"
                      >
                        <img
                          :src="$path + it.image"
                          alt=""
                          style="width: 90px; height: 68px"
                        />
                        <div
                          class="flex-column justify-content-space-between"
                          style="width: 200px"
                        >
                          <div
                            class="mob-goods-title flex justify-content-space-between align-items"
                          >
                            <span>{{ it.productName }}</span>
                            <span>￥{{ it.price }}</span>
                          </div>
                          <div class="mob-goods-num">X {{ it.num }}</div>
                        </div>
                      </div>
                      <div class="color-333 size-14 text-right">
                        总价：￥{{ item.totalMoney }}
                      </div>
                      <div class="size-14 color-666 text-right">
                        收货人：{{ item.name }} {{ item.phone }}
                      </div>
                      <div class="size-14 color-666 text-right">
                        地址：{{ item.address }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center" v-if="list.length != 0" style="margin-top: 20px">
                  <el-pagination
                    layout="prev, pager, next"
                    :page-size="rows"
                    :total="total"
                    @current-change="currentChange"
                  ></el-pagination>
                </div>
              </van-tab>
            </van-tabs>
          </div>
          <!--空状态-->
          <div class="text-center" v-if="list.length == 0">
            <van-empty>
              <div type="description" style="color: #969799">数据还在上传中</div>
            </van-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
export default {
  data() {
    return {
      menulist: [
        {
          id: "1",
          name: "待发货",
        },
        {
          id: "2",
          name: "待收货",
        },
        {
          id: "3",
          name: "已完成",
        },
      ],
      list: [],
      detail: {},
      changeStatus: "",
      page: 1,
      rows: 6,
      total: 0,
      clickStatus: 10086,
    };
  },
  created() {
	  if(window.localStorage.getItem("userinfo") == null){
		  this.$router.push({path:"/"})
	  }
    if (window.localStorage.getItem("changeStatus") != null) {
      this.changeStatus = window.localStorage.getItem("changeStatus");
    }
    if (this.changeStatus == "") {
      this.changeStatus = this.menulist[0].id;
    }
    this.getlist(this.changeStatus);
  },
  methods: {
    getlist(id) {
      this.$api.iotHome
        .personalCenterTable({
          state: id,
          page: this.page,
          rows: this.rows,
          customerPhone: JSON.parse(window.localStorage.getItem("userinfo")).phone,
        })
        .then((res) => {
          if (res.success == true) {
            console.log(res);
            this.list = res.data.orderList;
            this.total = res.data.count;
          }
        });
    },
    tohome(){
      this.$router.replace({path:'/'})
    },
    toconfirmReceipt(data) {
      this.$confirm("是否确认收货?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.iotHome
            .confirmReceipt({
              id: data.id,
              state: "3",
            })
            .then((res) => {
              if (res.success == true) {
                this.getlist(this.changeStatus);
              }
            });
        })
        .catch(() => {});
    },
    toconfirmReceipt2(data) {
      Dialog.confirm({
        message: "是否确认收货",
      })
        .then(() => {
          this.$api.iotHome
            .confirmReceipt({
              id: data.id,
              state: "3",
            })
            .then((res) => {
              if (res.success == true) {
                this.getlist(this.changeStatus);
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    tabChange(val) {
      window.localStorage.setItem("changeStatus", val);
      this.getlist(val);
    },
    currentChange(val) {
      this.page = val;
      this.getlist(this.changeStatus);
    },
    menuChange(data) {
      console.log(data.id);
      this.changeStatus = data.id;
      window.localStorage.setItem("changeStatus", data.id);
      this.page = 1;
      this.getlist(data.id);
    },
  },
};
</script>

<style>
@import url("../style/page.css");
</style>
